// Dependencies
import React from 'react'

// Components
import ChatFeed from './ChatFeed'
import {Icon, Button} from '@lazarusai/forms-ui-components'
import ChatInput from './ChatInput'

// Styles
import '../styles/Chat2.css'
import '../styles/Chat.css'

export default function Chat2(props) {
  return (
    <div
      id='chat-container'
      className='inner-chat-container'
      style={props.style}
    >
      {props.title &&
        <header>
          <span>{`{} `}</span>
          <span>{props.title}</span>
          {/* <Icon
            icon={'code-outline'}
            fill='var(--colors-brand-light-blue)'
          /> */}
        </header>
      }
      {/* knowledge portion here */}
      {props.feedTitle &&
        <p className='chat-sub-heading'>{props.feedTitle}</p>
      }
      <div id='inner-chat-container'>
        <div id='chat-wrapper-0'>
          {/* {props.prompts.map((prompt, i) => {
            return (
              <PromptCard
                key={props.id}
                id={props.id}
                title={prompt.title}
                questions={prompt.questions}
                answers={prompt.answers}
                confidence={prompt.confidence || 0}
                context={prompt.context || ''}
                theme={props.theme}
              />
            )
          })} */}
          <ChatFeed />
          <ChatInput />
        </div>
      </div>
      {props.hasInput && false &&
      <footer>
        <form
          id='chat-form'
          onSubmit={(e) => {
            document.getElementById('invisible-text-area').innerText = ''
            props.onSubmit(e)
          }}
        >
          <div className='text-area-wrapper'>
            <div
              id='invisible-text-area'
            />
            <textarea
              placeholder={props.newPromptPlaceholder}
              onChange={(e) => {
                document.getElementById('invisible-text-area').innerHTML =
                  e.target.value
                props.onChangeNewPrompt(e)
              }}
              id='thing'
              name='newPrompt'
              value={props.newPrompt}
              rows={1}
              form='chat-form'
              className='custom-txt-area'
            />
          </div>
          <Button
            theme={props.theme}
            form='chat-form'
            type={6}
            buttonType='submit'
            text={'Submit'}
            icon={
              <Icon
                icon={'arrow-forward-outline'}
                key={'submit'}
              />
            }
            iconPosition={'right'}
            isAutoResizing={true}
            iconJusitfy={'edge'}
            className={'chat-btn'}
          />
        </form>
      </footer>
      }
    </div>
  )
}
